"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = void 0;
const react_1 = __importDefault(require("react"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const checkbox_group_styles_1 = require("./checkbox-group-styles");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const checkbox_1 = require("../checkbox/checkbox");
function CheckboxGroup({ source, disabled, onChange, idMapper = (option) => option.id, labelMapper = (option) => option.name, form, value, }) {
    const classes = checkbox_group_styles_1.useStyles();
    const handleChange = event_callback_hook_1.useEventCallback((option) => {
        if (value === null || value === void 0 ? void 0 : value.includes(option)) {
            onChange(value === null || value === void 0 ? void 0 : value.filter((val) => val !== option));
        }
        else {
            onChange([...(value !== null && value !== void 0 ? value : []), option]);
        }
    });
    return (react_1.default.createElement("div", { className: classes.checkboxGroup }, source.items.map((option) => {
        var _a;
        const id = idMapper(option);
        return (react_1.default.createElement(FormControlLabel_1.default, { key: id, value: id, label: labelMapper(option), disabled: disabled, form: form, classes: {
                label: classes.labelLabel,
                root: classes.labelRoot,
            }, control: react_1.default.createElement(checkbox_1.Checkbox, { key: id, value: (_a = value === null || value === void 0 ? void 0 : value.includes(id)) !== null && _a !== void 0 ? _a : false, onChange: () => handleChange(id) }), className: classes.checkboxControl }));
    })));
}
exports.CheckboxGroup = CheckboxGroup;
//# sourceMappingURL=checkbox-group.js.map